import {Transition} from "@headlessui/react";
import React, {Fragment, useEffect, useState} from "react";
import CrossIcon from "@material-ui/icons/Close";
import CheckIcon from "@material-ui/icons/Check";
import {CheckCircle} from "@material-ui/icons";
import { ErrorRounded } from "@material-ui/icons";
import {Inertia} from "@inertiajs/inertia";

export default function FlashMessage({ message, type, }) {
    const [show, setShow] = useState(true)

    useEffect(() => {
        setShow(true);
        const timeout = setTimeout(() => {
            Inertia.reload({ only: ['flash'] });
        }, 10000);

        return () => {
            clearTimeout(timeout)
        };
    }, [message]);

    return (
        <div
            aria-live="assertive"
            className="pointer-events-none fixed inset-0 flex items-end px-4 py-6 sm:items-start sm:p-6"
        >
            <div className="flex w-full flex-col items-center space-y-4 sm:items-end">
                <Transition
                    show={show}
                    as={Fragment}
                    enter="transform ease-out duration-300 transition"
                    enterFrom="translate-y-2 opacity-0 sm:translate-y-0 sm:translate-x-2"
                    enterTo="translate-y-0 opacity-100 sm:translate-x-0"
                    leave="transition ease-in duration-100"
                    leaveFrom="opacity-100"
                    leaveTo="opacity-0"
                >
                    <div className="pointer-events-auto w-full max-w-sm overflow-hidden rounded-lg bg-white shadow-lg ring-1 ring-black ring-opacity-5">
                        <div className="p-4">
                            <div className="flex items-start">
                                <div className="flex-shrink-0">
                                    {
                                        type === 'warning' ?
                                            <ErrorRounded className={{
                                                "h-6 w-6": true,
                                                "text-green-400": type !== 'warning',
                                                "text-red-400": type === 'warning',
                                            }} aria-hidden="true"/>
                                        :
                                            <CheckCircle className={{
                                                "h-6 w-6": true,
                                                "text-green-400": type !== 'warning',
                                                "text-red-400": type === 'warning',
                                            }} aria-hidden="true"/>
                                    }
                                </div>
                                <div className="ml-3 w-0 flex-1 pt-0.5">
                                    {
                                        type === 'warning' ?
                                            <p className="text-sm font-medium text-gray-900 m-0">Error!</p>
                                            :
                                            <p className="text-sm font-medium text-gray-900 m-0">Success!</p>
                                    }
                                    <p className="mt-1 mb-0 text-sm text-gray-500">{ message }</p>
                                </div>
                                <div className="ml-4 flex flex-shrink-0">
                                    <button
                                        type="button"
                                        className="inline-flex rounded-md bg-white text-gray-400 hover:text-gray-500 focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:ring-offset-2"
                                        onClick={() => {
                                            Inertia.reload({ only: ['flash'] });
                                            setShow(false);
                                        }}
                                    >
                                        <span className="sr-only">Close</span>
                                        <CrossIcon className="h-5 w-5" aria-hidden="true"  />
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                </Transition>
            </div>
        </div>
    )
}
